//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import newApi from '@/utils/newModuleApi'

export default {
  data () {
    return { today: {}, trend: { dates: [], total_words: [] }, total: {} }
  },
  created () {
    this.$ajax.get(newApi.statsToday).then(res => { this.today = res || {} }).catch(() => {})
    this.$ajax.get(newApi.statsTrend + '?days=7').then(res => { this.trend = res || { dates: [], total_words: [] } }).catch(() => {})
    this.$ajax.get(newApi.statsTotal).then(res => { this.total = res || {} }).catch(() => {})
  },
  methods: {
    formatDuration (sec) {
      if (!sec) return '0分'
      return Math.floor(sec / 60) + '分'
    },
    barHeight (v) {
      const max = Math.max(...(this.trend.total_words || [1]), 1)
      return Math.max(4, (v || 0) * 60 / max)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/new/stats/home.vue